import { Component, OnDestroy } from "@angular/core";
import { ViewController } from "ionic-angular";
import { Store } from "@ngrx/store";
import { AppState } from "../../../app/models/app.state";
import { Subscription } from "rxjs/Subscription";
import {
  PatientListingColumnType,
  patientListingColumnOptions
} from "../../../app/models/types";
import * as UserActions from "../../../app/store/actions/user.actions";
import { take } from "rxjs/operators";

@Component({
  selector: "select-patient-listing-columns",
  templateUrl: "select-patient-listing-columns.component.html"
})
export class SelectPatientListingColumns implements OnDestroy {
  stateSubscription: Subscription;
  displayedColumns: PatientListingColumnType[] = ["age"];
  patientListingColumnOptions = patientListingColumnOptions;
  constructor(public viewCtrl: ViewController, public store: Store<AppState>) {
    this.stateSubscription = this.store
      .select(state => state)
      .pipe(take(1))
      .subscribe(state => {
        if (state.user.displayedColumnsInPatientListing !== null) {
          this.displayedColumns = state.user.displayedColumnsInPatientListing;
        } else {
          this.displayedColumns = state.config.ffDefaultColumnsInPatientListing;
        }
      });
  }

  close() {
    this.viewCtrl.dismiss();
  }

  ngOnDestroy() {
    this.stateSubscription.unsubscribe();
  }

  radioChecked(event, value) {
    if (!this.displayedColumns.includes(value)) {
      this.displayedColumns.push(value);
    } else {
      this.displayedColumns = this.displayedColumns.filter(
        elem => elem !== value
      );
    }
    this.store.dispatch(
      new UserActions.UpdateAction({
        displayedColumnsInPatientListing: this.displayedColumns
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-listing.page/select-patient-listing-columns.component/select-patient-listing-columns.component.ts